export const DeviceType = {
    mobile: "Mobile",
    tablet: "Tablet",
    pc: "PC",
};
